import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { NavLink } from 'react-router-dom'
import { useHistory } from "react-router-dom";
import Button from '../../Button';
import Image from "../../../../img/superseria_img@2x.png";

function Superseria(props) {
  const [answer_a, setAnswer_a] = useState(false);
  const [answer_b, setAnswer_b] = useState(false);
  const [answer_c, setAnswer_c] = useState(false);
  const history = useHistory();

  let validate = (e) => {
    e.preventDefault()

  }

  return (
    <div className="page activation-page">
      <section>
          <div className="page-header">
            <h1>Superseria - Początkujący</h1>
            <p>Sprzedaj <strong>trzy urządzenia BAT</strong> w czasie trwania sezonu, zostań Początkującym sprzdawcą i odbierz <strong>dodatkowe 15 zł!</strong></p>
            <p><strong>Powodzenia!</strong></p>
            <img className="activation-image" src={ Image } />
          </div>
        </section>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { screen, user, activations } = state
  return { screen, user, activations }
};

export default withRouter(connect(
  mapStateToProps,
  {

  }
)(Superseria));